import React from 'react';

/*
 * Exported from the Between DS. Filled rather than stroked, which is why these
 * sit apart from the outline set in the folder above - several of those names
 * are in use on other screens and must keep the drawing they have.
 *
 * The one change from the export: every fill is currentColor, so a row can
 * colour its own icon - see .sidebar-icon in side-nav.css. The exported size is
 * kept rather than forced square; two of these are not square, and the slot
 * caps them without stretching them.
 */

const BillingIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg"
         width={props.width ? props.width : '16'}
         height={props.height ? props.height : '15'}
         viewBox="0 0 16 15" fill="none"
    >
        <path d="M15 3.56667V1.66667C15 0.75 14.25 0 13.3333 0H1.66667C0.741667 0 0 0.75 0 1.66667V13.3333C0 14.25 0.741667 15 1.66667 15H13.3333C14.25 15 15 14.25 15 13.3333V11.4333C15.4917 11.1417 15.8333 10.6167 15.8333 10V5C15.8333 4.38333 15.4917 3.85833 15 3.56667ZM14.1667 5V10H8.33333V5H14.1667ZM1.66667 13.3333V1.66667H13.3333V3.33333H8.33333C7.41667 3.33333 6.66667 4.08333 6.66667 5V10C6.66667 10.9167 7.41667 11.6667 8.33333 11.6667H13.3333V13.3333H1.66667Z" fill="currentColor"/>
        <path d="M10.8333 8.75C11.5237 8.75 12.0833 8.19036 12.0833 7.5C12.0833 6.80964 11.5237 6.25 10.8333 6.25C10.143 6.25 9.58333 6.80964 9.58333 7.5C9.58333 8.19036 10.143 8.75 10.8333 8.75Z" fill="currentColor"/>
    </svg>
);

export default BillingIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/nav/BillingIcon.jsx